import {atom} from 'recoil';

const loadingState = atom({
  key: 'users_table_loading',
  default: true
})

const errorState = atom({
  key: 'users_table_error',
  default: false
})

const rowsState = atom({
  key: 'users_table_rows',
  default: []
})

const deleteModalOpenState = atom({
  key: 'users_table_delete_modal_open',
  default: false,
});

const deleteModalIdState = atom({
  key: 'users_table_delete_modal_id',
  default: '',
});

export {loadingState, errorState, rowsState, deleteModalOpenState, deleteModalIdState}